module.exports = __webpack_public_path__ + "assets/img/fail_refund.7fbfb8fc.png";